module.exports = __webpack_public_path__ + "img/fill-circle-check.3809b3.svg";